import { NgModule } from '@angular/core';
import { Routes, RouterModule,  } from '@angular/router';

const routes: Routes = [
  {path : 'swagger', loadChildren : './swagger/swagger.module#SwaggerModule'},
  {path : 'profile', loadChildren : './profile/profile.module#ProfileModule'},
  {path : 'recipe', loadChildren : () => import('./recipe/recipe.module').then(m => m.RecipeModule)},
  {path : 'metrics', loadChildren : () => import('./api-metrics/api-metrics.module').then(m => m.ApiMetricsModule)},
  {path : 'machine', loadChildren : () => import('./machine/machine.module').then(m => m.MachineModule)},
  {path : 'roaster', loadChildren : () => import('./roaster/roaster.module').then(m => m.RoasterModule)},
  {path : 'capsule', loadChildren : () => import('./capsule/capsule.module').then(m => m.CapsuleModule)},
  {path : 'ota', loadChildren : () => import('./ota/ota.module').then(m => m.OtaModule)},
  {path : 'home', loadChildren : './home/home.module#HomeModule'},
  {path: '',   redirectTo: '/home', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }